import analytics from 'analytics.js';
import bsn from 'libraries/bootstrap-native.js';
import events from 'events.js';
import ko from 'knockout';

const buttonTemplate = `
<!-- ko if: practices.length -->
    <a rel="nofollow"
        href="#"
        type="button"
        data-bind="click: showModal.bind($data), attr: {class: classList}">
        <!-- ko ifnot: hideIcon -->
            <i class="fa fa-phone fa-fw"></i>
        <!-- /ko -->
        Call Now
    </a>
<!-- /ko -->
`;

const modalTemplate = `
<div class="modal contact-modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content enquiry">
            <div class="modal-header">
                <span class="close" data-dismiss="modal" aria-label="Close"></span>
                <h4 class="js-modal-title modal-title">
                    <!-- ko if: practices.length > 1 -->
                        Select a Practice Location
                    <!-- /ko -->
                    <!-- ko if: practices.length === 1 -->
                        Contact details for
                        <div data-bind="text: name"></div>
                    <!-- /ko -->
                </h4>
            </div>
            <div class="modal-body top">
                <div class="container-fluid">
                    <div class="row modal-info">
                        <!-- ko if: practices.length > 1 -->
                            <div class="col-sm-12 select-wrapper">
                                <select class="select form-control" data-bind="
                                    options: practices,
                                    optionsText: function(item) {
                                        return item.localityName + ', ' + item.localityState;
                                    },
                                    value: selectedPractice
                                ">
                                </select>
                            </div>
                        <!-- /ko -->
                        <h3 class="location-name" data-bind="text: selectedPractice().name"></h3>
                        <div class="col-sm-12 address">
                            <span class="address-text" data-bind="text: selectedPractice().address"></span>
                        </div>
                        <a class="js-contact-number" data-bind="if: selectedPractice().number, attr: {href: selectedPracticeTelLink}">
                            <span class="fa fa-phone fa-fw"></span><span data-bind="text: selectedPractice().number"></span>
                        </a>
                    </div>
                </div>
            </div>
            <hr class="margin-0 margin-xs-top">
            <div class="modal-body bottom">
                <div class="container-fluid">
                    <div class="row modal-info">
                        <div class="col-sm-12">
                            <p>
                                Don't forget to mention you found
                                <b data-bind="text: name"></b> on HealthShare
                            </p>
                            <p>
                                As they are a <b>HealthShare partner</b>,
                                you may be able to find a more suitable
                                appointment.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;

export default class CallNowButtonModel {
    constructor(params, elem) {
        this.params = params;
        this.elem = elem;
        this.name = params.name;
        this.hideIcon = params.hideIcon || false;
        this.practices = params.practices || [];
        this.classList = params.classList;
        this.selectedPractice = ko.observable(
            params.practices.length ? params.practices[0] : null,
        );
        this.changedPracticeSelection = false;
        this.modalOpen = false;
        this.track = params.track;

        this.selectedPractice.subscribe(() => {
            this.changedPracticeSelection = true;
            this.trackPhoneSelect();
        });

        this.selectedPracticeTelLink = ko.pureComputed(() => {
            if (this.selectedPractice()) {
                const number = this.selectedPractice().number.replace(
                    /\s/g,
                    '',
                );
                return `tel:${number}`;
            }
            return '';
        });
        this.modal = null;

        document.body.insertAdjacentHTML('afterbegin', modalTemplate);
        this.modalElem = document.getElementsByClassName('contact-modal')[0];
        ko.applyBindings(this, this.modalElem);
    }

    async showModal() {
        await events.ready();
        if (!this.modal) {
            this.initModal();
        }
        this.modal.show();
        this.modalOpen = true;
    }

    initModal() {
        const modalNum = this.modalElem.getElementsByClassName(
            'js-contact-number',
        )[0];
        this.modal = new bsn.Modal(this.modalElem);

        // track modal close
        events.listen(this.modalElem, 'hidden.bs.modal', () => {
            if (!this.changedPracticeSelection) {
                this.trackPhoneSelect();
                this.modalOpen = false;
            }
            this.changedPracticeSelection = false;
        });

        // track window close
        events.listen(window, 'beforeunload', () => {
            if (document.activeElement === modalNum) {
                return;
            }
            if (!this.changedPracticeSelection && this.modalOpen) {
                this.trackPhoneSelect();
            }
        });
    }

    trackPhoneSelect() {
        if (this.track === 'location') {
            const trackData = {
                practiceLocationId: this.selectedPractice().id,
                phoneNumber: this.selectedPractice().number,
            };
            analytics.track('practiceLocationPhoneClick', trackData);
        } else {
            const trackData = {
                practitioner: this.selectedPractice().profileId,
                phone_number: this.selectedPractice().number,
                practice_position: this.selectedPractice().id,
            };
            analytics.track('practitionerPhoneClick', trackData);
        }
    }
}

ko.components.register('call-now-button', {
    viewModel: {
        createViewModel(params, info) {
            return new CallNowButtonModel(params, info.element);
        },
    },
    template: buttonTemplate,
});
